<template>
    <div>
        <SearchBox ref="SearchBox">
            <el-form slot="form" :inline="true" ref="searchParams" :model="searchParams" label-width="80px" class="unitWidth" size="small">
                <el-form-item :label="$t('Shift.factory')">
                    <el-select v-model="fcIdSelected" :placeholder="$t('base.PleaseSelect')" :clearable="isclear" :disabled="ischeck" filterable @change="searchTable()">
                        <el-option v-for="factory in factoryList" :key="factory.value" :label="factory.label" :value="factory.value"> </el-option>
                    </el-select>
                </el-form-item>
            </el-form>
        </SearchBox>
        <LabelContent :title="$t('Shift.ShiftList')" ref="LabelContent">
            <div slot="btns">
                <!--                <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()"> 新增</el-button>-->
                <span v-for="acc in access" :key="acc">
                  <el-button size="small" type="success" @click=";(ifAdd = true), updatehOpen()" v-if="acc == 'SL0001'" style="margin-right: 10px">{{$t('base.add')}}</el-button>
                </span>
                <el-button size="small" type="success" @click="exportShift">{{$t('base.export')}}</el-button>
                <!-- <el-button size="small" type="warning"> 批量移除</el-button> -->
            </div>
        </LabelContent>
        <div class="tableBox">
            <el-table stripe ref="multipleTable" :data="tableData" class="center">
                <!--                <el-table-column type="selection" width="55" />-->
                <el-table-column prop="fcName" :label="$t('Shift.factory')" show-overflow-tooltip />
                <el-table-column prop="sfCode" :label="$t('Shift.ShiftCode')" show-overflow-tooltip />
                <el-table-column prop="sfName" :label="$t('Shift.Shift')" show-overflow-tooltip />
                <el-table-column :label="$t('Shift.startTime')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.sfStartMinute >= 10"> {{ scope.row.sfStartHour }}:{{ scope.row.sfStartMinute }} </span>
                        <span v-if="scope.row.sfStartMinute < 10">{{ scope.row.sfStartHour }}:0{{ scope.row.sfStartMinute }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('Shift.endTime')" show-overflow-tooltip>
                    <template slot-scope="scope">
                        <span v-if="scope.row.sfEndMinute >= 10"> {{ scope.row.sfEndHour }}:{{ scope.row.sfEndMinute }} </span>
                        <span v-if="scope.row.sfEndMinute < 10">{{ scope.row.sfEndHour }}:0{{ scope.row.sfEndMinute }}</span>
                    </template>
                </el-table-column>
                <el-table-column :label="$t('base.operation')" width="100">
                    <template slot-scope="scope">
                        <!--                        <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" />-->
                        <span v-for="acc in access" :key="acc">
                          <i class="editBtn iconfont u-youjianbianji" @click=";(ifAdd = false), updatehOpen(scope.row)" v-if="acc == 'SL0002'" />
                          <i class="delBtn iconfont u-shanchu" @click="deleteRow(scope.row)" v-if="acc == 'SL0003'" />
                        </span>
                    </template>
                </el-table-column>
            </el-table>
            <el-pagination
                @size-change="paginationChange"
                @current-change="paginationCurrentChange"
                :current-page="searchParams.page"
                :page-sizes="[10, 20, 50, 100]"
                :page-size="searchParams.pageSize"
                layout="total, sizes, prev, pager, next, jumper"
                :total="searchParams.pageCount"
            />
        </div>
        <el-dialog :title="ifAdd ? $t('base.add') : $t('base.update')" width="500px" :visible.sync="updateShow" style="text-align: left" @close="resetForm">
            <el-form :model="shiftForm" :rules="rules" ref="shiftForm" label-width="180px" class="demo-roleForm">
                <el-form-item style="justify-content: center" :label="$t('Shift.factory')" prop="fcCode">
                    <el-select v-model="shiftForm.fcCode" :placeholder="$t('base.PleaseSelect')" :disabled="ischeck" filterable @change="selectChange">
                        <el-option v-for="factory in factoryData" :key="factory.factoryId" :label="factory.fcName" :value="factory.fcCode"> </el-option>
                    </el-select>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.scShift')" prop="sfName">
                    <el-input v-model="shiftForm.sfName"></el-input>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.ShiftCode')" prop="sfCode">
                    <el-input v-model="shiftForm.sfCode"></el-input>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.startTime') + $t('Shift.HH')" prop="sfStartHour">
                    <!--<el-input v-model="shiftForm.sfStartHour"></el-input>-->
                    <el-input-number v-model="shiftForm.sfStartHour" :min="0" :max="23"></el-input-number>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.startTime')+$t('Shift.mm')" prop="sfStartMinute">
                    <!--<el-input v-model="shiftForm.sfStartMinute"></el-input>-->
                    <el-input-number v-model="shiftForm.sfStartMinute" :min="0" :max="59"></el-input-number>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.endTime')+$t('Shift.HH')" prop="sfEndHour">
                    <!--<el-input v-model="shiftForm.sfEndHour"></el-input>-->
                    <el-input-number v-model="shiftForm.sfEndHour" :min="0" :max="23"></el-input-number>
                </el-form-item>
                <el-form-item style="justify-content: center" :label="$t('Shift.endTime')+$t('Shift.mm')" prop="sfEndMinute">
                    <!--<el-input v-model="shiftForm.sfEndMinute"></el-input>-->
                    <el-input-number v-model="shiftForm.sfEndMinute" :min="0" :max="59"></el-input-number>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button @click="updateShow = false">{{$t('base.cancel')}}</el-button>
                <el-button type="primary" @click="updateShift('shiftForm')">{{ ifAdd ? $t('base.add') : $t('base.update') }}</el-button>
            </span>
        </el-dialog>
    </div>
</template>

<script>
import { addShift, delShift, editShift, getAllShift } from '../../../libs/api'

export default {
  name: 'shiftList',
  data () {
    return {
      updateShow: false,
      ifAdd: false,
      userInfo: {},
      searchParams: {
        param: {},
        pageSize: 10,
        page: 1,
        pageCount: 0
      },
      fcIdSelected: '',
      factoryTree: [],
      tableData: [],
      shiftForm: {
        fcCode: String,
        sfName: String,
        sfCode: String,
        sfStartHour: Number,
        sfStartMinute: Number,
        sfEndHour: Number,
        sfEndMinute: Number
      },
      rules: {
        fcCode: [
          {
            required: true,
            message: this.$t('Shift.factory'),
            trigger: 'blur'
          }
        ],
        sfName: [
          {
            type: 'string',
            required: true,
            message: this.$t('Shift.scShift'),
            trigger: 'blur'
          }
        ],
        sfCode: [
          {
            type: 'string',
            required: true,
            message: this.$t('Shift.ShiftCode'),
            trigger: 'blur'
          }
        ],
        sfStartHour: [
          {
            required: true,
            message: this.$t('Shift.startTime')+this.$t('Shift.HH'),
            trigger: 'blur'
          }
        ],
        sfStartMinute: [
          {
            required: true,
            message: this.$t('Shift.startTime')+this.$t('Shift.mm'),
            trigger: 'blur'
          }
        ],
        sfEndHour: [
          {
            required: true,
            message: this.$t('Shift.endTime')+this.$t('Shift.HH'),
            trigger: 'blur'
          }
        ],
        sfEndMinute: [
          {
            required: true,
            message: this.$t('Shift.endTime')+this.$t('Shift.mm'),
            trigger: 'blur'
          }
        ]
      },
      factoryData: [],
      access: [],
      role: [],
      ischeck: true,
      scopeDisabled: '',
      isclear: false
    }
  },
  computed: {
    factoryList: function () {
      var arr = []
      var userInfo = JSON.parse(sessionStorage.getItem("userInfo"))
      if (this.factoryTree != undefined && this.factoryTree.length > 0) {
        if (this.ischeck) {
          for (var i = 0;i < this.factoryTree.length;i++) {
            for (let j = 0;j < userInfo.roles.length;j++) {
              if (this.factoryTree[i].deptID == userInfo.roles[j].factoryId) {
                arr.push({
                  label: this.factoryTree[i].deptName,
                  id: this.factoryTree[i].deptID,
                  value: JSON.stringify(this.factoryTree[i]),
                  deptLevel: this.factoryTree[i].deptLevel,
                  parent: 0
                })
              }
            }
          }
        } else {
          for (var i = 0;i < this.factoryTree.length;i++) {
            arr.push({
              label: this.factoryTree[i].deptName,
              id: this.factoryTree[i].deptID,
              value: JSON.stringify(this.factoryTree[i]),
              deptLevel: this.factoryTree[i].deptLevel,
              parent: 0
            })
          }
        }
      }
      return arr
    }
  },
  mounted () {
    this.access = JSON.parse(sessionStorage.getItem('auths'))
    // this.userInfo = sessionStorage.getItem("userInfo")
    this.userInfo = this.$store.state.userInfo
    var role = this.userInfo.roles
    for (var i = 0;i < role.length;i++) {
      //所有工厂数据
      if (role[i].factoryId == 0) {
        this.ischeck = false
        this.role = role[i]
        this.scopeDisabled = false
        this.isclear = true
        break
      } else {
        if (this.userInfo.factoryId == role[i].factoryId) {
          this.role = role[i]
        }
      }
    }
    this.getData()
    this.getFactory()
  },
  methods: {
    resetForm() {
      this.$refs.shiftForm.resetFields();
    },
    getData () {
      var self = this
      let options = {
        method: 'GET',
        url: this.$api.departTree
      }
      this.$http.request(options).then(response => {
        this.factoryTree = response.data
        for (var i = 0;i < self.factoryTree.length;i++) {
          if (self.factoryTree[i].deptID == self.role.factoryId) {
            self.fcIdSelected = JSON.stringify(self.factoryTree[i])
          }
        }
        this.searchTable()
      })
    },
    getFactory () {
      let options = {
        methods: 'GET',
        url: this.$api.getAllFactory
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.factoryData = []
          var aa = response.data
          if (this.ischeck) {
            var role = JSON.parse(sessionStorage.getItem("userInfo")).roles
            for (let i = 0;i < aa.length;i++) {
              for (let j = 0;j < role.length;j++) {
                if (aa[i].factoryId == role[j].factoryId) {
                  this.factoryData.push(aa[i])
                }
              }
            }
          } else {
            this.factoryData = response.data
          }
        }
      })
    },
    /**
     *查询用户列表
     *  查询参数对象 searchParams
     **/
    searchTable () {
      let queryParams = {
        pageSize: this.searchParams.pageSize,
        pageNum: this.searchParams.page
      }
      if (this.fcIdSelected != null && this.fcIdSelected != '') {
        queryParams['fcCode'] = JSON.parse(this.fcIdSelected).deptCode
      }
      let options = {
        method: 'GET',
        params: queryParams,
        url: this.$api.getAllShift
      }
      this.$http.request(options).then(response => {
        if (response.status == 100) {
          this.tableData = response.data.list
          this.searchParams.pageCount = response.data.total
        }
      })
    },
    paginationChange (val) {
      this.searchParams.pageSize = val
      this.searchTable()
    },
    paginationCurrentChange (val) {
      this.searchParams.page = val
      this.searchTable()
    },
    updatehOpen (row) {
      if (this.ifAdd) {
        //新增
        this.shiftForm = {}
        if (this.ischeck) {
          this.shiftForm.fcCode = this.userInfo.fcCode
        }
        this.updateShow = true
      } else {
        //编辑
        this.shiftForm = JSON.parse(JSON.stringify(row))
        this.updateShow = true
      }
    },
    updateShift (shiftForm) {
      if (this.ifAdd) {
        this.$refs[shiftForm].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              showLoading: true,
              url: this.$api.addShift,
              data: this.shiftForm
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.$message.success(this.$t('base.SuccessfullyAdded'))
                this.updateShow = false
                this.searchTable()
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      } else {
        this.$refs[shiftForm].validate((valid) => {
          if (valid) {
            let options = {
              method: 'POST',
              showLoading: true,
              url: this.$api.editShift,
              data: this.shiftForm
            }
            this.$http.request(options).then(response => {
              if (response.status == 100) {
                this.$message.success(this.$t('base.SuccessfullyUpdated'))
                this.updateShow = false
                this.searchTable()
              } else {
                this.$message.error(response.message)
              }
            })
          } else {
            return false
          }
        })
      }
    },
    selectChange () {
      this.$forceUpdate()
    },
    deleteRow (row) {
      this.$confirm(this.$t('msg.TipsText'), this.$t('msg.Tips'), {
        confirmButtonText: this.$t('base.delete'),
        cancelButtonText: this.$t('base.cancel'),
        type: 'warning'
      })
        .then(() => {
          this.$http
            .request({
              method: 'POST',
              headers: { 'content-type': 'application/json' },
              params: { sfId: row.sfId },
              url: this.$api.delShift
            })
            .then(response => {
              this.searchTable()
              // this.$message.success(response.message);
            })
            .catch(err => {
              this.searchTable()
              // this.$message.error(err);
            })
        })
        .catch(() => {
          this.searchTable()
          this.$message({
            type: 'info',
            message: this.$t('msg.cancel')
          })
        })
    },
    async exportShift () {
      let params = {}
      if (this.fcIdSelected != null && this.fcIdSelected != '') {
        params['fcCode'] = this.fcIdSelected
      }
      params['language'] = this.$t('lang')
      let options = {
        url: this.$api.exportShift,
        method: 'POST',
        params: params,
        responseType: 'blob',
        headers: {
          "Content-Type": "application/json;application/ms-excel;application/ms-excel;charset=utf-8"
        }
      }
      let result = await this.$http.request(options)
      var elink = document.createElement('a')
      elink.download = this.$t('Shift.ShiftInfo')  //设置名称
      elink.style.display = 'none'
      var blob = new Blob([result], { type: 'application/vnd.ms-excel' })
      elink.href = URL.createObjectURL(blob)
      document.body.appendChild(elink)  //追加节点
      elink.click()
      document.body.removeChild(elink)  //删除节点
    }
  }
}
</script>

<style scoped>
</style>
